import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dashboardPreferencesValidator(control: AbstractControl): ValidationErrors | null {
  switch (control.get('filterMode')?.value) {
    case 'recent':
      let error = {};
      const lastField = control.get('recentFilterAmount');
      const unitField = control.get('recentFilterUnit');

      if (!lastField?.value || lastField.value.length === 0) {
        error = { ...error, recentLastFieldEmpty: true };
      }
      if (!unitField?.value || unitField.value === '') {
        error = { ...error, unitFieldEmpty: true };
      }
      return error;
    case 'time-span':
      const utcFrom = control.get('timeSpanFilterFrom');
      const utcTo = control.get('timeSpanFilterTo');
      if ((!utcFrom?.value || utcFrom.value === '') && (!utcTo?.value || utcTo.value === '')) {
        return { timeSpanBothEmpty: true };
      }
      if (utcFrom?.value && utcTo?.value && new Date(utcFrom.value) >= new Date(utcTo.value)) {
        return { fromGreaterThanTo: true };
      }
      return null;
    case 'last-x':
      const lastXField = control.get('lastXRecords');
      return !lastXField?.value || lastXField.value.length === 0 ? { lastXEmpty: true } : null;
  }
  return null;
}
